<div class="container">
    <h1 class="page-title"><span class="icon"><i class="fas fa-scroll"></i></span>{{ 'ShippingStatus.Header' | translate }}</h1>
    <p-card>
        <p-accordion>
            <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
                <form>
                    <div class="p-fluid formgrid grid">
                        <div class="field col-12">
                            <label>{{ 'DOQuery.Header' | translate }}</label>
                            <div class="formgrid grid">
                                <div class="col-6">
                                    <p-radioButton name="orderType" value="1" label="{{ 'ShippingStatus.Search.Urgent' | translate }}" [(ngModel)]="orderType"></p-radioButton>
                                    <p-radioButton name="orderType" value="2" class="ml-4" label="{{ 'ShippingStatus.Search.OverOrder' | translate }}" [(ngModel)]="orderType"></p-radioButton>
                                    <p-radioButton name="orderType" value="3" class="ml-4" label="{{ 'ShippingStatus.Search.PersonOrder' | translate }}" [(ngModel)]="orderType"></p-radioButton>
                                    <p-radioButton name="orderType" value="4" class="ml-4" label="{{ 'ShippingStatus.Search.All' | translate }}" [(ngModel)]="orderType"></p-radioButton>
                                </div>
                            </div>
                        </div>
                        <div class="field col-12">
                            <label>{{ 'ShippingStatus.Search.StatusQuery' | translate }}</label>
                            <div class="formgrid grid">
                                <div class="col">
                                    <p-radioButton name="orderStatus" value="1" label="{{ 'ShippingStatus.Search.LeaveWare' | translate }}" [(ngModel)]="orderStatus"></p-radioButton>
                                    <p-radioButton name="orderStatus" value="2" class="ml-4" label="{{ 'ShippingStatus.Search.HasnotLeave' | translate }}" [(ngModel)]="orderStatus"></p-radioButton>
                                    <p-radioButton name="orderStatus" value="3" class="ml-4" label="{{ 'ShippingStatus.Search.All' | translate }}" [(ngModel)]="orderStatus"></p-radioButton>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ShippingStatus.Search.Customer' | translate }}</label>
                            <input pInputText type="text" [(ngModel)]="consigneeCompany" [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'DOQuery.Search.Facility' | translate }}</label>
                            <p-multiSelect [options]="facilityOptions" [(ngModel)]="selectedFacility" [ngModelOptions]="{standalone: true}"></p-multiSelect>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3"></div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ShippingStatus.Search.DONum' | translate }}</label>
                            <input pInputText type="text" [(ngModel)]="doNo" [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ShippingStatus.Search.CustomerPO' | translate }}</label>
                            <input pInputText type="text" />
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3"></div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ShippingStatus.Search.EstimateLeave' | translate }}</label>
                            <div class="formgrid grid">
                                <div class="col">
                                    <p-calendar name="startDate" [(ngModel)]="startDate" dateFormat="yy/mm/dd" [defaultDate]="startDate">
                                    </p-calendar>
                                </div> ~
                                <div class="col">
                                    <p-calendar name="endDate" [(ngModel)]="endDate" dateFormat="yy/mm/dd" [defaultDate]="endDate">
                                    </p-calendar>
                                </div>
                            </div>
                        </div>
                        <div class="col-8 pt-2">
                            <button (click)="dateChange($event, 1)" pButton pRipple label="{{ 'ShippingStatus.Button.Today' | translate }}" class="p-button-sm"></button>
                            <button (click)="dateChange($event, 2)" pButton pRipple label="{{ 'ShippingStatus.Button.ThreeDaysBefore' | translate }}" class="p-button-sm ml-2"></button>
                            <button (click)="dateChange($event, 3)" pButton pRipple label="{{ 'ShippingStatus.Button.OneWeekBefore' | translate }}" class="p-button-sm ml-2"></button>
                            <button (click)="dateChange($event, 4)" pButton pRipple label="{{ 'ShippingStatus.Button.TwoWeeksBefore' | translate }}" class="p-button-sm ml-2"></button>
                            <button (click)="dateChange($event, 5)" pButton pRipple label="{{ 'ShippingStatus.Button.OneMonthBefore' | translate }}" class="p-button-sm ml-2"></button>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick($event)"></button>
                            <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtnClick($event)" class="p-button-secondary ml-2"></button>
                        </div>
                    </div>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div class="mt-2">
            <p-table #DODataTable laasDataTableSetting [tableKey]="preferenceKey" [defaultColumns]="columns" [value]="DORows" [(selection)]="selectedDORows" [selectable]="true" [loading]="isLoading" columnResizeMode="expand" class="datatable" styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                  <laas-table-column-toggle
                    [optionsColumn]="columns"
                    [dataTable]="DODataTable">
                  </laas-table-column-toggle>
                  <button pButton pRipple class="ml-4" label="{{ 'ShippingStatus.Button.DOUrgent' | translate }}" (click)="priorityBtnClick($event)" [disabled]="selectedDORows.length === 0"></button>
                </ng-template>
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <col style="width: 3vw;">
                        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th>
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th [pSortableColumn]="col.field" *ngFor="let col of columns" pResizableColumn pReorderableColumn [attr.field]="col.field">
                            {{ col.header | translate }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                        </td>
                        <td *ngFor="let col of columns">
                            <ng-container [ngSwitch]="col.field">
                                <ng-container *ngSwitchCase="'doNo'">
                                    <div class="overflow-text">
                                        <a href="javascript: void(0);" (click)="DOLinkClick($event, rowData)">{{rowData[col.field]}}</a>
                                        <p-tag *ngIf="rowData.priority === '1'" class="ml-2" severity="danger" value="急"></p-tag>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'estimatedLeaveWarehouseDt'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'fixedEstimatedLeaveWarehouseDt'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'leaveWarehouseDt'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'doStatus'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | optionsMapping:DOStatusOptions }}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'reasons'">
                                    <ol *ngIf="rowData[col.field].length > 0; else defaultDisplay">
                                        <li *ngFor="let reason of rowData[col.field]">
                                            <div class="overflow-text">
                                                {{ reason }}
                                            </div>
                                        </li>
                                    </ol>
                                    <ng-template #defaultDisplay>
                                        -
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngSwitchCase="'download'">
                                    <!-- <p-dropdown appendTo="body" *ngIf="rowData.downloadOptions.length > 0" [(ngModel)]="rowData.selectedDownload" [options]="rowData.downloadOptions" optionLabel="text" optionValue="value" (onChange)="downloadChange($event, rowData)"></p-dropdown> -->
                                    <div class="overflow-text">
                                        <button pButton pRipple [label]="'檔案上傳 ( ' + rowData.badges + ' )'" class="p-button-outlined p-button-help" (click)="fileBtnClick($event, rowData)"></button>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <div class="overflow-text">
                                        {{rowData[col.field]}}
                                    </div>
                                </ng-container>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length + 1" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>
    <laas-dofile-management [display]="showDoFile" [doNo]="doNoFile" (onClose)="closeFile($event)"></laas-dofile-management>
</div>
